
import _ from 'lodash';
import React, { Component } from "react";
import PropTypes from "prop-types";
import { MoneyInput } from "react-spark";
import {
  withValidationOutputDefaultProps,
  withValidationOutputPropTypes,
  sharedFormInputPropTypes,
  sharedFormInputDefaultProps
} from "../hocs/prop-types";
import { withValidation } from "../hocs/WithValidation";

class URCMoneyInput extends Component {
  static cleanValue(value="") {
    return String(value).replace(/[^\d\.]/g, "");
  }

  static defaultProps = {
    ...withValidationOutputDefaultProps,
    ...sharedFormInputDefaultProps,
    value: "",
    parentContainerClassName: null
  };

  static propTypes = {
    ...withValidationOutputPropTypes,
    ...sharedFormInputPropTypes,
    value: PropTypes.string,
    parentContainerClassName: PropTypes.string
  };

  componentDidMount() {
    this.props.context.registerFormElement({
      value: this.props.value,
      name: this.props.name,
      valid: this.props.validateOnRegisterUpdate.apply(this),
      validate: this.props.handleValidation
    });
  }

  componentDidUpdate() {
    if (this.props.forceUpdate) {
      this.props.context.updateFormElement({
        value: this.props.value,
        name: this.props.name,
        valid: this.props.validateOnRegisterUpdate.apply(this)
      });
    }
  }

  handlePaste(event) {
    if(this.props.context && this.props.context.addPField) {
      this.props.context.addPField(event.target.name);
    }
  }

  render() {
    const {
      id,
      name,
      value,
      context,
      handleChange,
      handleBlur,
      label,
      disabled,
      errorMessage,
      className,
      helper,
      noCents,
      parentContainerClassName,
      placeholder,
      type
    } = this.props;
    
    let resolveValue = ()=>{
      return _.get(context, `elements[${name}].value`) || value
    }
    const resolvedValue = resolveValue();

    return (
      <MoneyInput
        className={className}
        disabled={disabled}
        error={errorMessage}
        id={id}
        label={label}
        name={name}
        onChange={event => handleChange(event, context)}
        onBlur={event => handleBlur(event, context.handleChange)}
        onPaste={event => this.handlePaste(event)}
        value={resolvedValue}
        helper={helper}
        noCents={noCents}
        placeholder={placeholder}
        parentContainerClassName={parentContainerClassName}
        type={type}
      />
    );
  }
}

export const cleanValue = URCMoneyInput.cleanValue;

export default withValidation(URCMoneyInput);
